import { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useFetchDataSolicitacaoById } from '@hooks/api/Solicitacao/useFetchDataSolicitacaoById.js';
import { FormProvider, useForm } from 'react-hook-form';
import { CustomLoader } from '@components/UI/CustomLoader/Index.jsx';
import { useFetchDataByProcessoUnidade } from '@hooks/api/Solicitacao/useFetchDataByProcessoUnidade.js';
import PageWrapper from '@components/UI/PageWrapper/Index.jsx';
import ComplianceSection from '@components/Solicitacao/Admin/Edit/Sections/ComplianceSection/Index.jsx';
import EditSection from '@components/Solicitacao/Admin/Edit/Sections/EditSection/Index.jsx';
import ItensProcessoSection from '@components/Solicitacao/Admin/Edit/Sections/ItensProcessoSection/Index.jsx';
import ButtonActionsSection from '@components/Solicitacao/Admin/Edit/Sections/ButtonActions/Index.jsx';
import StatusSolicitacaoSection from '@components/Solicitacao/Shared/Sections/StatusSection/Index.jsx';
import SolicitacaoHistoricoSection from '@components/Solicitacao/Shared/Sections/HistoricoSection/Index.jsx';

const EditSolicitacao = () => {
  const { id } = useParams();
  const { solicitacaoFields, loading, error } = useFetchDataSolicitacaoById(id);
  const [solicitacaoProcessoItems, setSolicitacaoProcessoItems] = useState([]);

  useEffect(() => {
    if (solicitacaoFields?.solicitacaoProcessoItems) {
      setSolicitacaoProcessoItems(solicitacaoFields.solicitacaoProcessoItems);
    }
  }, [solicitacaoFields]);

  const {
    relatorios,
    planosAcao,
    loadingDocs,
    errorDocs,
  } = useFetchDataByProcessoUnidade(
    solicitacaoFields?.compliance?.idProcesso,
    solicitacaoFields?.unidadeGerencia?.id
  );

  const navigate = useNavigate();

  const defaultValues = useMemo(() => ({
    numeroSolicitacao: solicitacaoFields?.numeroSolicitacao,
    emailCC: solicitacaoFields?.emailCC,
    idTemplateEmailComunicado: solicitacaoFields?.templateEmailComunicado?.value || null,
    idTemplateEmailSolicitacao: solicitacaoFields?.templateEmailSolicitacao?.value || null,
    idTemplateEmailRelatorio: solicitacaoFields?.templateEmailRelatorio?.value || null,
    idAuditor: solicitacaoFields?.auditor?.id,
    dataSolicitacao: solicitacaoFields?.dataSolicitacao,
    prazoSolicitacao: solicitacaoFields?.prazoSolicitacao,
    dataLimiteSolicitacao: solicitacaoFields?.dataLimiteSolicitacao,
    dataAgendarEnvio: solicitacaoFields?.dataAgendarEnvio || null,
    observacoes: solicitacaoFields?.observacoes,
    solicitacaoProcessoItems: solicitacaoProcessoItems,
    statusSolicitacao: solicitacaoFields?.statusSolicitacao
  }), [solicitacaoFields, solicitacaoProcessoItems]);

  const methods = useForm({ defaultValues });

  if (error || errorDocs) {
    return (
      navigate('/404')
    );
  }

  const isReady = !loading && !loadingDocs && solicitacaoFields;

  if (!isReady) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <CustomLoader text={"Carregando os dados da solicitação..."} />
      </div>
    );
  }

  return (
    <PageWrapper>
      <FormProvider {...methods}>
        <div>

          {/* Compliance associado a solicitação  */}
          <ComplianceSection
            solicitacaoFields={solicitacaoFields}
            loading={loading}
            error={error}
          />

          {/* Campos para editar a solicitação  */}
          <EditSection
            solicitacaoFields={solicitacaoFields}
            loading={loading}
            error={error}
          />

          {/* Itens do Processo associados a solicitação */}
          <ItensProcessoSection
            solicitacaoFields={solicitacaoFields}
            solicitacaoProcessoItems={solicitacaoProcessoItems}
            setSolicitacaoProcessoItems={setSolicitacaoProcessoItems}
          />

          {/*  Botões da solicitação */}
          <ButtonActionsSection
            methods={methods}
            solicitacaoFields={solicitacaoFields}
            relatorios={relatorios}
            planosAcao={planosAcao}
            solicitacaoProcessoItems={solicitacaoProcessoItems}
          />

          {/*  Status da Solicitação */}
          <StatusSolicitacaoSection
            solicitacaoFields={solicitacaoFields}
          />

          {/*  Histórico da Solicitação */}
          <SolicitacaoHistoricoSection
            solicitacaoFields={solicitacaoFields}
          />

        </div>
      </FormProvider>
    </PageWrapper>
  );
}

export default EditSolicitacao;